import React from 'react';
import { Check, AlertCircle } from 'lucide-react';

const AlertModal = ({ alertModal, setAlertModal }) => {
  if (!alertModal.show) return null;

  const getIconClass = () => {
    switch (alertModal.type) {
      case 'success': return 'text-success-600 dark:text-success-400';
      case 'error': return 'text-danger-600 dark:text-danger-400';
      case 'warning': return 'text-warning-600 dark:text-warning-400';
      default: return 'text-info-600 dark:text-info-400';
    }
  };

  const getIcon = () => {
    if (alertModal.type === 'success') {
      return <Check className={`mt-0.5 h-5 w-5 flex-shrink-0 ${getIconClass()}`} />;
    }
    return <AlertCircle className={`mt-0.5 h-5 w-5 flex-shrink-0 ${getIconClass()}`} />;
  };

  return (
    <div className="fixed inset-0 bg-gray-950/40 dark:bg-black/70 flex items-center justify-center z-50">
      <div className="max-w-md w-full overflow-hidden m-4 rounded-xl bg-white shadow-overlay ring-1 ring-gray-900/5 dark:bg-gray-800 dark:ring-white/10">
        <div className="flex items-start justify-between gap-4 border-b border-gray-100 px-6 py-4 dark:border-white/[0.06]">
          <div className="flex min-w-0 items-start gap-2.5">
            {getIcon()}
            <h3 className="text-base font-semibold text-gray-900 dark:text-gray-50">{alertModal.title}</h3>
          </div>
        </div>
        <div className="px-6 py-5">
          <p className="text-sm text-gray-600 leading-relaxed dark:text-gray-300">{alertModal.message}</p>
        </div>
        <div className="flex flex-wrap items-center justify-end gap-2 border-t border-gray-100 bg-gray-50/70 px-6 py-3.5 dark:border-white/[0.06] dark:bg-white/[0.02]">
          <button
            onClick={() => setAlertModal({ show: false, title: '', message: '', type: 'info' })}
            className="btn btn-primary"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
